module.exports = __webpack_public_path__ + "img/logo3.e77a2938.png";